import React, { useState, useEffect } from 'react'
import { Timeline, Spin, Empty, Button } from 'antd'
import {
	UpOutlined,
	DownOutlined,
	// FilterOutlined
} from '@ant-design/icons'
import { number } from 'prop-types'
import api from 'services/api'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import relativeTime from 'dayjs/plugin/relativeTime'
import ReactMarkdown from 'react-markdown'

dayjs.extend(relativeTime)
dayjs.locale('pt-br')

const LogsView = ({ document_id }) => {
	const [logs, setLogs] = useState([])
	const [loading, setLoading] = useState(false)
	const [expandedKeys, setExpandedKeys] = useState([])

	useEffect(() => {
		if (document_id) {
			fetchLogs()
		}
	}, [document_id])

	const fetchLogs = async () => {
		try {
			setLoading(true)
			const response = await api.get(`/documents/${document_id}/logs`)
			setLogs(response.data || [])
		} catch (error) {
			console.error('Erro ao buscar logs:', error)
			setLogs([])
		} finally {
			setLoading(false)
		}
	}

	const handleExpand = (key) => {
		setExpandedKeys((prev) =>
			prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
		)
	}

	const formatDate = (dateString) => {
		if (!dateString) return ''
		return dayjs(dateString).format('DD/MM/YYYY [às] HH:mm')
	}

	const formatRelativeTime = (dateString) => {
		if (!dateString) return ''
		return dayjs(dateString).fromNow()
	}

	// Group logs by date
	const groupLogsByDate = (logs) => {
		const grouped = {}
		logs.forEach((log) => {
			const date = dayjs(log.created_at)
				.locale('pt-br')
				.format('dddd, DD [de] MMMM [de] YYYY')
			if (!grouped[date]) {
				grouped[date] = []
			}
			grouped[date].push(log)
		})
		return grouped
	}

	const groupedLogs = groupLogsByDate(logs)
	const dates = Object.keys(groupedLogs).sort((a, b) => {
		return (
			dayjs(b, 'dddd, DD [de] MMMM [de] YYYY').valueOf() -
			dayjs(a, 'dddd, DD [de] MMMM [de] YYYY').valueOf()
		)
	})

	if (loading) {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<Spin size="large" />
			</div>
		)
	}

	if (logs.length === 0) {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<Empty description="Nenhum log encontrado para este documento." />
			</div>
		)
	}

	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '20px',
				}}>
				<h3>Logs</h3>
				{/* TODO: uncomment when add filters */}
				{/* <Button icon={<FilterOutlined />} onClick={fetchLogs}>
					Filtrar
				</Button> */}
			</div>

			<div style={{ position: 'relative' }}>
				{dates.map((date, dateIndex) => {
					return (
						<div key={date}>
							{/* {dateIndex > 0 && (
								<div
									style={{
										height: '1px',
										backgroundColor: '#E8E8E8',
										margin: '20px 0',
										position: 'relative',
									}}>
									<div
										style={{
											position: 'absolute',
											left: '50%',
											transform: 'translateX(-50%)',
											backgroundColor: '#fff',
											padding: '0 10px',
											color: '#666',
											fontSize: '12px',
										}}>
										{date}
									</div>
								</div>
							)} */}
							{dateIndex >= 0 && (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}>
									<p
										style={{
											backgroundColor: '#F2F4F7',
											padding: '4px 8px',
											marginBottom: '20px',
											color: '#666',
											fontSize: '12px',
											borderRadius: '4px',
										}}>
										{date}
									</p>
								</div>
							)}

							<Timeline
								style={{
									marginTop: dateIndex === 0 ? '20px' : '0',
									paddingLeft: '20px',
								}}>
								{groupedLogs[date].map((log, logIndex) => {
									const isExpanded = expandedKeys.includes(log.id)
									return (
										<Timeline.Item
											key={log.id}
											color="#722ED1"
											style={{ paddingBottom: '20px' }}>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'flex-start',
													marginBottom: '8px',
												}}>
												<div style={{ flex: 1 }}>
													<div
														style={{
															color: '#999',
															fontSize: '12px',
															marginBottom: '4px',
														}}>
														{log.responsible}
													</div>
													<div
														style={{
															fontWeight: 'bold',
															fontSize: '16px',
															marginBottom: '4px',
														}}>
														{log.title}
													</div>
													<div
														style={{
															color: '#999',
															fontSize: '12px',
														}}>
														{formatDate(log.created_at)}
													</div>
												</div>
												<Button
													type="text"
													icon={isExpanded ? <UpOutlined /> : <DownOutlined />}
													onClick={() => handleExpand(log.id)}
													style={{
														color: '#722ED1',
														fontSize: '12px',
													}}>
													{isExpanded ? 'Esconder' : 'Mostrar'}
												</Button>
											</div>

											{isExpanded && (
												<div
													style={{
														backgroundColor: '#F9F0FF',
														padding: '16px',
														borderRadius: '4px',
														marginTop: '12px',
													}}>
													<div
														style={{
															marginBottom: '12px',
															whiteSpace: 'pre-wrap',
															wordBreak: 'break-word',
														}}>
														<ReactMarkdown>{log.description}</ReactMarkdown>
													</div>
													<div
														style={{
															color: '#999',
															fontSize: '12px',
														}}>
														Aconteceu {formatRelativeTime(log.created_at)}
													</div>
													<div
														style={{
															marginTop: '8px',
															color: '#666',
															fontSize: '12px',
														}}>
														Responsável: {log.responsible}
													</div>
												</div>
											)}
										</Timeline.Item>
									)
								})}
							</Timeline>
						</div>
					)
				})}
			</div>
		</div>
	)
}

LogsView.propTypes = {
	document_id: number,
}

export default LogsView
